type JourneyProfileType = 'funcionario' | 'participante' | 'gestor';
type ManagerJourneyStage = 'etapa1' | 'etapa2' | 'etapa3';

const FUNCIONARIO_CHALLENGE_ORDER = [
  'FiwbxsD',
  'FiwbM5P',
  'Fiwb2MF',
  'Fiwcnvh',
  'FiwcAya',
  'Fiwc6QJ'
];

const PARTICIPANTE_CHALLENGE_ORDER = [
  'FodzghB',
  'FiwbM5P',
  'Fiwb2MF',
  'Fiwcnvh',
  'FiwcAya',
  'FodzBKN',
  'FodzTpb',
  'FodAq4u'
];

const GESTOR_CHALLENGE_ORDER: Partial<Record<ManagerJourneyStage, string[]>> = {
  etapa1: [
    'FohRQJm',
    'FiwbM5P',
    'Fiwb2MF',
    'Fiwcnvh',
    'FohR25H',
    'FohSwEF',
    'FohSSjL'
  ]
};

const getManagerChallengeOrder = (stage: ManagerJourneyStage): string[] => {
  return GESTOR_CHALLENGE_ORDER[stage] || GESTOR_CHALLENGE_ORDER.etapa1 || [];
};

const resolveJourneyProfile = (extra: any): JourneyProfileType => {
  const habilitado = extra?.habilitado;
  const isManager = extra?.is_manager;

  if (habilitado === true && isManager === true) return 'gestor';
  if (habilitado === true && isManager === false) return 'participante';

  return 'funcionario';
};

const getJourneyChallengeIds = (
  profile: JourneyProfileType,
  managerStage: ManagerJourneyStage = 'etapa1'
): string[] => {
  if (profile === 'gestor') {
    return getManagerChallengeOrder(managerStage);
  }

  if (profile === 'participante') {
    return PARTICIPANTE_CHALLENGE_ORDER;
  }

  return FUNCIONARIO_CHALLENGE_ORDER;
};

const filterChallengesByJourneyProfile = <T extends { id: string }>(
  challenges: T[],
  userExtra: any,
  managerStage: ManagerJourneyStage = 'etapa1'
): T[] => {
  const profile = resolveJourneyProfile(userExtra);
  const challengeOrder = getJourneyChallengeIds(profile, managerStage);

  if (!challengeOrder.length) return challenges;

  const orderMap = new Map(challengeOrder.map((challengeId, index) => [challengeId, index]));

  return challenges
    .filter((challenge) => orderMap.has(challenge.id))
    .sort((challengeA, challengeB) => {
      return (orderMap.get(challengeA.id) ?? 0) - (orderMap.get(challengeB.id) ?? 0);
    });
};

export { filterChallengesByJourneyProfile };
